import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';

// Styled component for ContentWrapper
export const StyledContentWrapper = styled('div', {
  variants: {
    mobileScreen: {
      true: {
        padding: '0px',
        marginLeft: '11px',
        marginRight: '11px',
      },
      false: {
        padding: '8px',
        marginLeft: '8px',
        marginRight: '8px',
      },
    },
  },
});

// Styled component for Text
export const StyledTitleText = styled('h2', {
  color: '#002677', // Add !important if needed
  '@media (min-width: 465px)': {
    fontWeight: 'bold',
    fontSize: '26px',
    display: 'flex',
    height: '26px',
    width: 'auto',
    gap: '4px',
    marginTop: '10px',
  },
  '@media (max-width: 464px)': {
    fontWeight: '700',
    letterSpacing: '0px',
    fontSize: '20px',
    display: 'flex',
    height: '26px',
    width: '90%',
    gap: '4px ',
    marginTop: '16px',
    lineHeight: '120%',
  },
});

export const StyledSubtitleText = styled('h3', {
  color: '#002677',
  fontFamily: '$heading',
  '@media (min-width: 465px)': {
    fontWeight: 'bold',
    fontSize: '28.83px',
    display: 'flex',
    height: '36px',
    width: 'auto',
    gap: '4px',
    marginTop: '13px',
    fontFamily: 'UHC/Mobile Headings/H2 | Semibold',
    lineHeight: '36px',
  },
  '@media (max-width: 464px)': {
    fontWeight: 'bold',
    fontSize: '28.83px',
    display: 'flex',
    height: '54px',
    width: 'auto',
    alignItems: 'center',
    gap: '4px',
    marginTop: '20px',
    fontFamily: 'UHC/Mobile Headings/H2 | Semibold',
    lineHeight: '36px',
  },
});

export const StyledDescriptionText = styled('p', {
  color: '#4B4D4F',
  '@media (min-width: 465px)': {
    fontWeight: '500',
    fontSize: '16px',
    display: 'flex',
    height: '36px',
    width: 'auto',
    alignItems: 'center',
    gap: '4px',
    fontFamily: 'UHC/Mobile Headings/H2 | Semibold',
  },
  '@media (max-width: 464px)': {
    fontWeight: '500',
    fontSize: '16px',
    display: 'flex',
    height: '36px',
    width: 'auto',
    alignItems: 'center',
    gap: '4px',
    marginTop: '10px',
    fontFamily: 'UHC/Mobile Headings/H2 | Semibold',
  },
});

export const StyledMaybeLaterButton = styled(Button, {
  '&.abyss-button-root': {
    marginRight: '$md',
    marginTop: '15px',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid #002677',
    color: '#002677',
  },
  variants: {
    mobileScreen: {
      true: {
        '&.abyss-button-root': {
          marginLeft: '0px',
          marginBottom: '15px',
        },
      },
      false: {
        '&.abyss-button-root': {
          marginLeft: '10px',
          marginBottom: '8px',
        },
      },
    },
  },
});

export const StyledLearnMoreButton = styled(Button, {
  '&.abyss-button-root': {
    marginTop: '22px',
  },
});

export const StyledDynamicContent = styled('p', {
  color: '#4B4D4F',
  variants: {
    mobileScreen: {
      true: {
        fontWeight: 'light',
        fontSize: '16px',
        height: '24px',
        width: 'auto',
        alignItems: 'center',
        gap: '4px',
        marginTop: '10px',
        marginBottom: '30px',
      },
      false: {
        fontWeight: 'light',
        fontSize: '16px',
        height: '24px',
        width: 'auto',
        alignItems: 'center',
        gap: '4px',
      },
    },
  },
});

export const StyledListItemText = styled('div', {
  fontFamily: '$core.color.neutral.100 !important',
  fontWeight: '700 !important',
  fontSize: '20.25px !important',
  lineHeight: '20px !important',
  letterSpacing: '0px',
  color: '#002677',
  marginLeft: '6px',
  marginTop: 0,
  marginBottom: 0,

  variants: {
    mobileScreen: {
      true: {
        fontSize: '16.25px !important',
      },
    },
  },
});

export const BaseFlexContainer = styled('li', {
  marginTop: '16px',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  listStyleType: 'none',
});

// Styled component for FlexContainer
export const StyledFlexContainer = styled(BaseFlexContainer, {
  display: 'flex',
  flexDirection: 'row',
  variants: {
    leftPadding: {
      true: {
        marginLeft: '20px',
      },
      false: {
        marginLeft: '0px',
      },
    },
  },
});
